export enum MensagemControleSituacao {
  FALHA_PROCESSAMENTO = <any> 'FALHA_PROCESSAMENTO',
  NAO_PROCESSADA = <any> 'NAO_PROCESSADA',
  QUARENTENA = <any> 'QUARENTENA',
  SUSPENSA = <any> 'SUSPENSA'
}
